import { useSyncExternalStore } from 'react';
import { loadConversationAudio } from './conversationAudio';
import { getRate } from './playbackRate';

/** Проигрывание отрезка разговора из примеров сводки (AC3/AC5).
 *
 *  Один элемент на страницу: запустили второй пример — первый замолкает. Файл
 *  берём тем же загрузчиком, что и плеер разговора (в память, без range-запросов
 *  к хранилищу, от которых плеер зависал). Играет с t до t+dur (время файла). */
type State = { key: string | null; loading: boolean };

let state: State = { key: null, loading: false };
const subs = new Set<() => void>();
const emit = (next: State) => { state = next; subs.forEach((f) => f()); };
let audio: HTMLAudioElement | null = null;
let stopAt = 0;
let token = 0;

function stop() {
  token += 1;
  if (audio) audio.pause();
  emit({ key: null, loading: false });
}

async function play(key: string, conversationId: number, start: number, dur: number) {
  if (state.key === key) { stop(); return; }
  const mine = ++token;
  if (audio) audio.pause();
  emit({ key, loading: true });
  try {
    const { url } = await loadConversationAudio(conversationId);
    if (mine !== token) return;
    if (!audio) {
      audio = new Audio();
      audio.addEventListener('timeupdate', () => {
        if (audio && audio.currentTime >= stopAt) stop();
      });
      audio.addEventListener('ended', stop);
    }
    if (audio.src !== url) audio.src = url;
    const from = Math.max(0, start - 0.2);
    stopAt = start + dur + 0.4;
    audio.currentTime = from;
    audio.playbackRate = getRate();
    await audio.play();
    if (mine === token) emit({ key, loading: false });
  } catch {
    if (mine === token) emit({ key: null, loading: false });
  }
}

export function useSnippetPlayer() {
  const s = useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state);
  return { playingKey: s.key, loading: s.loading, play, stop };
}
